import { ValidationSchema } from '../../../../../../../validations/interfaces';
import { Validation } from '../../../../../../../validations/Validation';
import { currencyFormatter } from '../../../../../../../utils/formatters';
import { RulesetResult } from '../../business/rules';
import loanFormModel from '../../form_models/loanFormModel';
import * as Yup from 'yup';
import { MaturityPaymentAcknowledgementRuleset } from '../../business/ruleset';

const { maturityPaymentAcknowledgement } = loanFormModel.formField;

export class MaturityPaymentAcknowledgementValidation
  implements ValidationSchema
{
  public name = maturityPaymentAcknowledgement.name;
  public label = maturityPaymentAcknowledgement.getLabel(
    currencyFormatter.format(1000)
  );
  public type = 'boolean';

  public required = {
    message: '',
    value: false,
  };

  public nullable = true;
  public ruleset = MaturityPaymentAcknowledgementRuleset;

  public when(schema: Yup.BooleanSchema, context: any, result: RulesetResult) {
    const required = !!(result & RulesetResult.REQUIRED);
    return schema.test({
      name: 'maturityPaymentAcknowledgementTest',
      test: function (value) {
        if (required) {
          // Field is required - validate it has value and is true
          return (
            value ||
            this.createError({
              message: maturityPaymentAcknowledgement.requiredErrorMsg,
            })
          );
        } else {
          // Field is not required - any value is acceptable
          return true;
        }
      },
    });
  }
}
export default new Validation(new MaturityPaymentAcknowledgementValidation());
